export { AppConfigModule } from './app-config.module';
export { AppConfigService } from './app-config.service';
export { AppConfigType } from './types';
export { DocumentPageType } from './components';
